export default __webpack_public_path__ + "static/media/secondfoundation.e9eeb505.png";